import { render } from "./TranslationModal.vue?vue&type=template&id=df352e54&scoped=true"
import script from "./TranslationModal.vue?vue&type=script&lang=js"
export * from "./TranslationModal.vue?vue&type=script&lang=js"

import "./TranslationModal.vue?vue&type=style&index=0&id=df352e54&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df352e54"]])

export default __exports__